/*
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：オーディオサービス
 *
 * 作成者：2022/2/11 ノア）黄
 * 最終修正者：2022/2/11 ノア）黄
 *
 */
import TtiAudio from './TtiAudio.vue'

/**
 * オーディオサービス
 *
 * @class
 */
class AudioService {
  /**
   * オーディオのインスタンス
   */
  private audioInstance: TtiAudio | undefined

  /**
   * オーディオのインスタンスを初期化する
   *
   * @param {TtiAudio} instance オーディオのインスタンスを初期化する
   * @returns {void}
   */
  init(instance: TtiAudio): void {
    this.audioInstance = instance
  }

  /**
   * オーディオを再生する。
   *
   * @returns {void}
   */
  play(): void {
    if (!this.audioInstance || !this.audioInstance.$refs || !this.audioInstance.$refs.audio) {
      return
    }

    const audioEl = this.audioInstance.$refs.audio as HTMLAudioElement
    audioEl.play()
  }
}

const audioService = new AudioService()
export { audioService }
